// Shared date-preset helpers used by /dashboard, /leads, and /tasks so all
// three pages agree on what "This week" or "Last month" means.
// Weeks start Monday (Indian business convention).

export const DATE_PRESETS = [
  { key: "today",       label: "Today"      },
  { key: "yesterday",   label: "Yesterday"  },
  { key: "this_week",   label: "This week"  },
  { key: "last_week",   label: "Last week"  },
  { key: "this_month",  label: "This month" },
  { key: "last_month",  label: "Last month" },
];

function fmtYmd(d) {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

// Returns [startYmd, endYmd] for the given preset key. Empty strings for "all".
export function computeDatePreset(preset) {
  const now = new Date(); now.setHours(0, 0, 0, 0);
  const dow = now.getDay();                            // 0 Sun … 6 Sat
  const mondayOffset = dow === 0 ? 6 : dow - 1;
  const monday = new Date(now); monday.setDate(now.getDate() - mondayOffset);
  const sunday = new Date(monday); sunday.setDate(monday.getDate() + 6);
  switch (preset) {
    case "today":     return [fmtYmd(now), fmtYmd(now)];
    case "yesterday": {
      const y = new Date(now); y.setDate(now.getDate() - 1);
      return [fmtYmd(y), fmtYmd(y)];
    }
    case "this_week": return [fmtYmd(monday), fmtYmd(sunday)];
    case "last_week": {
      const lm = new Date(monday); lm.setDate(monday.getDate() - 7);
      const ls = new Date(sunday); ls.setDate(sunday.getDate() - 7);
      return [fmtYmd(lm), fmtYmd(ls)];
    }
    case "this_month": {
      const s = new Date(now.getFullYear(), now.getMonth(), 1);
      const e = new Date(now.getFullYear(), now.getMonth() + 1, 0);
      return [fmtYmd(s), fmtYmd(e)];
    }
    case "last_month": {
      const s = new Date(now.getFullYear(), now.getMonth() - 1, 1);
      const e = new Date(now.getFullYear(), now.getMonth(), 0);
      return [fmtYmd(s), fmtYmd(e)];
    }
    default: return ["", ""];
  }
}
